import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'

import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'
import {Action} from 'vuex-class'


@Component({})
export default class MessagesAndLettersComponent extends AfterFetchComponent {


  @Action('downloadLetter', StoreNamespace.MESSAGES_AND_LETTERS) downloadLetter: any
  @Action('fetchMessagesAndLetters', StoreNamespace.MESSAGES_AND_LETTERS) fetchMessagesAndLetters: any

  private searchLoansFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []
  private dataDate: any = "";
  private messageContentSelectedToDisplay: string = ""
  private userName: string = ''
  private showMessageContent: boolean = false;


  mounted() {

    this.initColumns();
    this.initSearchFields();
    this.fetchMessagesAndLetters({requestorCallback: this, requestBody: {pageNumber: 0, pageSize: 10}})
  }

  private initSearchFields(): void {
    this.searchLoansFields.push({
      label: 'messagesAndLetters.id',
      property: 'identificationNumber',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 10,
      advancedOnly: false,
      bootstrapColumn: 4
    })
    this.searchLoansFields.push({
      label: 'messagesAndLetters.name',
      property: 'fullName',
      fieldType: FieldType.TEXT_FIELD,
      advancedOnly: false,
      bootstrapColumn: 4
    })
    this.searchLoansFields.push({
      label: 'messagesAndLetters.phoneNumber',
      property: 'phoneNumber',
      fieldType: FieldType.TEXT_FIELD,
      advancedOnly: false,
      bootstrapColumn: 4,
    })
  }

  private initColumns(): void {
    this.columns.push({property: 'identificationNumber', header: 'messagesAndLetters.id',  hideSorting:true } as GridColumn);
    this.columns.push({property: 'fullName', header: 'messagesAndLetters.name',  hideSorting:true} as GridColumn);
    this.columns.push({property: 'mailingType', header: 'messagesAndLetters.mailingType',  hideSorting:true } as GridColumn);
    this.columns.push({property: 'phoneNumber', header: 'messagesAndLetters.phoneNumber',  hideSorting:true } as GridColumn);
    this.columns.push({property: 'emailAddress', header: 'messagesAndLetters.emailAddress',  hideSorting:true } as GridColumn);
    this.columns.push({property: 'distributionDate', header: 'messagesAndLetters.dateAndTime'} as GridColumn);
    this.columns.push({property: 'messageType', header: 'messagesAndLetters.messageType',hideSorting:true } as GridColumn);
  }

  private getGridData(searchObject: any): void {


    this.fetchMessagesAndLetters({
      requestorCallback: this,
      requestBody: searchObject
    })
  }

  private onExportClick() {
    this.downloadLetter({
      requestorCallback: this,
      pathVariable: "letterKey"
    })
  }


  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {
      case 'fetchMessagesAndLetters':
        this.$emit('successResults', data)
        break;
      case 'downloadLetter':
        break;
    }
  }

  private onShowMessageContent(data: any) {
    this.messageContentSelectedToDisplay = data.messageContent
    this.userName = data.fullName
    this.showMessageContent = true
  }

}